// extracted by mini-css-extract-plugin
module.exports = {"root":"SetPasswdForm_root__3RKSG","label":"SetPasswdForm_label__1mjCV"};